var CompanySize = {
	"Company size": "Dimensioni dell'azienda",
	"1-19 employees": "1-19 dipendenti",
	"20-99 employees": "20-99 dipendenti",
	"100-499 employees": "100-499 dipendenti",
	"500-999 employees": "500-999 dipendenti",
	"1,000-9,999 employees": "1.000-9.999 dipendenti",
	"10,000 employees or more": "10.000 dipendenti o più"
};

export { CompanySize as default };
